import React, { Component } from "react";

import styles from "./driverUnitsBar.module.scss";
import DriverUnitItem from "./DriverUnitItem";

class DriverUnitListItems extends Component {
  render() {
    const { handleScrollTo, data, currentUser } = this.props;

    if (currentUser === null) {
      return null;
    }

    return data.map((item) => {
      /*   const isCheck = currentUser.units.some((x) => {
        return x.id === item.id;
      });
 */
      return (
        <div className={styles.container_userUnitsListItem} key={item.id}>
          <DriverUnitItem data={item} handleScrollTo={handleScrollTo} />
        </div>
      );
    });
  }
}

export default React.memo(DriverUnitListItems);
